@if (dir; as d) {
  <mat-icon inline aria-hidden="false" [class]="'dir ' + d" [attr.aria-label]="d === 'reprise' ? 'Reprise' : 'Installation'" [attr.title]="d === 'reprise' ? 'Reprise' : 'Installation'">{{ d === 'reprise' ? 'arrow_back' : 'arrow_forward' }}</mat-icon>
}
